module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.divClassName ? _vm.divClassName : ''
  }, [(_vm.isTikTok) ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.tiktokHandle,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.tiktokHandle))]) : _vm._e(), _vm._v(" "), (_vm.isInstagram) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openLink('http://instagram.com/' + _vm.instagramHandle)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#E1306C !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.instagramHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isFacebook && _vm.facebookHandle) ? _c('a', {
    attrs: {
      "href": 'https://facebook.com/' + _vm.facebookHandle,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#1877F2 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-facebook")]), _vm._v(" @" + _vm._s(_vm.facebookHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isLinkedIn && _vm.linkedinHandle) ? _c('a', {
    attrs: {
      "href": 'https://www.linkedin.com/in/' + _vm.linkedinHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#0A66C2 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" @" + _vm._s(_vm.linkedinHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isTwitter && _vm.twitterHandle) ? _c('a', {
    attrs: {
      "href": 'https://x.com/' + _vm.twitterHandle,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/x-logo.svg",
      "width": "15px",
      "alt": "",
      "aria-hidden": "true"
    }
  }), _vm._v(" @" + _vm._s(_vm.twitterHandle))]) : _vm._e(), _vm._v(" "), (_vm.isYoutube) ? _c('a', {
    attrs: {
      "href": _vm.showYoutubeURL(_vm.youtubeURL),
      "target": "_blank"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "#FF0000 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-youtube")]), _vm._v(" @" + _vm._s(_vm.youtubeHandle))], 1) : _vm._e(), _vm._v(" "), (_vm.isXiaohongshu) ? _c('a', {
    on: {
      "click": function($event) {
        return _vm.openLink('https://www.xiaohongshu.com/user/profile/' + _vm.xiaohongshuHandle)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/xhs-black.png",
      "width": "20px"
    }
  }), _vm._v(" " + _vm._s(_vm.xiaohongshuFullName || _vm.xiaohongshuHandle))]) : _vm._e(), _vm._v(" "), (_vm.isOthers) ? _c('a', [_c('v-icon', {
    staticStyle: {
      "color": "#616161 !important"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-help-circle")]), _vm._v(" " + _vm._s(_vm.otherHandle))], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-018c7d96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/SocialHandle.vue
// module id = 1968
// module chunks = 0